import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";
import { DatePicker, Radio } from "antd";
import moment from "moment";
import locale_es from "antd/es/date-picker/locale/es_ES";
import locale_it from "antd/es/date-picker/locale/it_IT";
import { FormattedMessage } from "react-intl";

const RangePicker = DatePicker.RangePicker;

const VaporRangeDatePicker = props => {
  const {
    className,
    style,
    disabled,
    disabledDate,
    dropdownClassName,
    format,
    onBlur,
    onChange,
    locale,
    value,
    placeholder,
    placement,
    allowEmpty,
    allowClear,
    size,
    suffixIconStyle,
    customTrigger
  } = props;

  const [state, setState] = React.useState(value);
  const [stateRadio, setStateRadio] = React.useState(0);

  const middleOnChange = (e, value) => {    
    setStateRadio(0);
    setState(e);
    if (onChange)
      onChange(e, value);
  };

  const middleOnBlur = (e) => {
    if (onBlur)
      onBlur(e);
  };

  useEffect(() => {
    setState(value);
  }, [value]);

  return (
    <RangePicker
      className={`vapor-date-picker ${className}`}
      style={style}
      disabled={disabled}
      dropdownClassName={dropdownClassName}
      getPopupContainer={(trigger) => customTrigger ? document.querySelector(".ant-table-tbody") : trigger.parentNode}
      value={state}
      format={format}
      onBlur={middleOnBlur}
      disabledDate={disabledDate}
      locale={locale === "es" ? locale_es : locale_it}
      onChange={middleOnChange}
      allowEmpty={allowEmpty}
      allowClear={allowClear}
      separator={"-"}
      suffixIcon={
        <FontAwesomeIcon
          icon={["far", "calendar"]}
          style={{
            ...suffixIconStyle,
            fontSize: 14,
            color: "#152935"
          }}
        />
      }
      size={size}
      /* ranges={{
        Oggi: [moment(), moment()],
        'Questa settimana': [moment().startOf('week'), moment().endOf('week')],
        'Questo mese': [moment().startOf('month'), moment().endOf('month')]
      }} */
      placeholder={placeholder}
      placement={placement}
      panelRender={(original) => {
        return (
          <div className="vapor-date-picker panel">
            <div className="header">
              <span className="date-title"><FormattedMessage id="generic.calendar.title" defaultMessage={"CALENDARIO"} /></span>
              <Radio.Group value={stateRadio} onChange={(e) => {
                const value = e.target.value;
                setStateRadio(value);
                let newDate = [null, null];
                switch (value) {
                case 1:
                  newDate = [moment(), moment()];
                  break;
                case 2:
                  newDate = [moment().startOf("week"), moment().endOf("week")];
                  break;
                case 3:
                  newDate = [moment().startOf("month"), moment().endOf("month")];
                  break;
                default:
                  newDate = [null, null];
                  break;
                }
                setState(newDate);
                onChange(newDate);
              }}>
                <Radio value={1}><FormattedMessage id="generic.calendar.today" defaultMessage={"Oggi"} /></Radio>
                <Radio value={2}><FormattedMessage id="generic.calendar.thisWeek" defaultMessage={"Questa settimana"}/></Radio>
                <Radio value={3}><FormattedMessage id="generic.calendar.thisMonth" defaultMessage={"Questo mese"}/></Radio>
              </Radio.Group>
            </div>
            {original}
          </div>
        );
      }}
    />
  );
};

VaporRangeDatePicker.propTypes = {
  allowEmpty: PropTypes.array,
  allowClear: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  disabledDate: PropTypes.func,
  dropdownClassName: PropTypes.string,
  format: PropTypes.array,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.any,
  placement: PropTypes.oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]),
  value: PropTypes.any,
  size: PropTypes.oneOf([undefined, "large", "middle", "small"]),
  locale: PropTypes.oneOf(["it", "es"]),
  suffixIconStyle: PropTypes.object,
  customTrigger: PropTypes.bool
};

VaporRangeDatePicker.defaultProps = {
  allowEmpty: [true, true],
  allowClear: true,
  className: "",
  style: {},
  disabled: false,
  disabledDate: undefined,
  dropdownClassName: "",
  format: ["DD/MM/YYYY", "DD-MM-YYYY", "DDMMYYYY"],
  locale: "it",
  onBlur: undefined,
  onChange: undefined,
  placeholder: undefined,
  placement: "bottomLeft",
  value: undefined,
  size: undefined,
  suffixIconStyle: {},
  customTrigger: false
};

export default VaporRangeDatePicker;
